module.exports = {
    "DefaultView": {
        "Projection": "EPSG:3857",
        "MinZoom": 0,
        "MaxZoom": 21.32,
        "Zoom": 15.0,
        "CenterX": -6557200,
        "CenterY": -8903000,
        "Scale":2500
    },

    "AvailableEPSG": [
        {
            "Name": "WGS 84 Web Mercator",
            "EPSG": "3857"
        },
        {
            "Name": "WGS 84 / UTM zone 21S",
            "EPSG": "32721"
        },
        {
            "Name": "WGS 84 / UTM zone 22S",
            "EPSG": "32722"
        },
        {
            "Name": "WGS 84 - Geográfica",
            "EPSG": "4326"
        },
        {
            "Name": "Antarctic Polar Stereographic",
            "EPSG": "3031"
        }
    ],

    "EnabledTools":{
        "LayerDisplay":{
            
            "Activated":true,
            "DefaultVisible":true,
            "ToggleVisibleButton":true,
            "DefaultVisibleMobile":true,

            "LayerOptions":{

                "LayerName":true,
                "LayerFormat":true,
                "LayerLicense":true,
                "LayerToggleVisible":true,

                "ContextMenuOptions":{
                    "Activated":true,
                    "OpRename":true,
                    "OpZoomToLayer":true,
                    "OpTableDisplay":true,
                    "OpMetadata":true,
                    "OpSymbolEdit":true,
                    "OpSymbolEditLayer":true,
                    "OpSymbolDeleteLayer":true,
                    "OpSymbolDownloadLayer":true,
                    "OpSymbolTransparency":true
                }
            }
        },
        "TopTools":{
            "JustifyContent":"space-between",
            "UiComponents":[
                {
                    "InUI":true,
                    "Type":"button",
                    "ID":"btn_create_layer",
                    "ComponentParems":{
                        "IsEnabled":true,
                        "IsVisible":true,
                        "Name":"Crear Layer",
                        "IconSRC":"",
                        "ToolTip":"New button...",
                        "Functions":[{
                            "FunctionName":"OpenWindow",
                            "FunctionParams":{
                                "WindowName":"CreateLayer"
                            }
                        }]
                    }
                },
                {
                    "InUI":true,
                    "Type":"container",
                    "Paremeters":{
                        "IsEnabled":true,
                        "IsVisible":true,
                        "JustifyContent":"space-between",
                        "Name":"Links Container",
                        "UiComponents":[
                            {
                                "InUI":true,
                                "Type":"button",
                                "ID":"btn_open_story_map",
                                "ComponentParems":{
                                    "IsEnabled":true,
                                    "IsVisible":true,
                                    "Name":"Story Map",
                                    "ToolTip":"Story Map \nEl IGM en la Antártida",
                                    "Functions":[{
                                        "FunctionName":"ExternalLink",
                                        "FunctionParams":{
                                            "Link":"http://igm.gub.uy/",
                                            "NewTab":true
                                        }
                                    }]
                                }
                            },
                            {
                                "InUI":true,
                                "Type":"Separator",
                                "ID":"sep_01",
                                "ComponentParems":{
                                    "IsEnabled":true,
                                    "IsVisible":true,
                                    "Name":"buton name",
                                }
                            },
                            {
                                "InUI":true,
                                "Type":"button",
                                "ID":"btn_open_iau_page",
                                "ComponentParems":{
                                    "IsEnabled":true,
                                    "IsVisible":true,
                                    "Name":"Link - Pagina I.A.U.",
                                    "ToolTip":"Página Institto Antártico Uruguayo",
                                    "Functions":[{
                                        "FunctionName":"ExternalLink",
                                        "FunctionParams":{
                                            "Link":"https://iau.gub.uy/",
                                            "NewTab":true
                                        }
                                    }]
                                }
                            }
                        ]
                    }
                }
            ],
            
            "ActiveButons":{

                "SaveLoadMap":true,

                "Separator1":true,

                "CreateLayer":true,
                "LoadLayerFile":true,
                "LoadLayerWMS":true,
                "DownloadImage":true,

                "Separator2":true,

                "EditLayers":true,
                "EditLayersOptions":{
                    "SelectFeature":true,
                    "PointFeature":true,
                    "LineFeature":true,
                    "PoligonFeature":true
                },
                "MeasureLine":true,
                "MeasuserArea":true,
                "CheckFeatureInfo":true,
                "DesactivateInteractionButton":true,

                "Separator3":true,

                "StoryMapIGM":true,
                "CustomeLinks":[
                    {
                        "Tooltip":"Pagina del IGM",
                        "Link":"http://igm.gub.uy/",
                        "TargetNewWindow":true,
                        "IconSrc":"http://imagenlink.com"
                    }
                ],

                "Separator4":true,

                "Fullscreen":true,
                "QuickHelp":true,
                "LongHelp":{
                    "Link":"link al pdf",
                    "Name":"nombre boton"
                },

                "OptionsButon":{
                    "ProjectionChange":true,

                    "InterfaceColors":true,
                    "LayerDisplayBackground":true
                }
            }
            

        },

        "BigLogo":{
            "NormalLogoSrc":"Link",
            "HoverLogoSrc":"Link",

            "Tooltip":"Pagina del IGM",

            "RoundLogo":true,

            "VisibleMobile":true
        },

        "RightBar":{
            "ZoomDefaultExtent":true,

            "RotateButton":true,
            "RotateAngle":30,

            "ZoomButton":true,
            "ZoomDistance":1,

            "ZoomSlider":true            
        },

        "BottomBar":{
            "ActualProjection":true,
            "MouseCordenate":true,
            "ExtraText":"Instituto Geográfico Militar",
            "TodayDate":true
        },

        "StartQuikHelp":true,

        "NorthArrow":true,
        "ScaleBar":true
    },

    "DefaultData": [
        {
            "Type": "Layer",
            "Activated": true,
            "CustomName": "Mapa de Base, Agua",
            "Description":"Mapa vectorial con el fondo de agua, solo se utiliza para mejorar la comodidad visual.",
            "Format": "GeoJSON",
            "Parameters": {
                "URL": "./VectorLayers/MapaDeBase_Agua.geojson",
                "LayerNames": [
                    "0",
                    "1"
                ],
                "LayerTitles": [
                    "Mapa de Base - Agua",
                    "Mapa de Base - Agua_"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "Symbol": [
                    {
                        "Type": "fill",
                        "Color": "rgba(156, 192, 249, 1)",
                        "ZIndex": null
                    }
                ]
            }
        },

        {
            "Type": "Layer",
            "Activated": true,
            "CustomName": "Mapa de Base, Terreno Isla Rey Jorge",
            "Description":"Mapa vectorial con los politonos de suelo de la Isla Rey Jorge, solo se utiliza para mejorar la comodidad visual. visible hasta escala 1:200.000",
            "Format": "GeoJSON",
            "Parameters": {
                "URL": "./VectorLayers/SueloAntartidaIsla_HighRes.geojson",
                "LayerNames": [
                    "0",
                    "1"
                ],
                "LayerTitles": [
                    "Suelo BCAA (Alta Resolución)",
                    "Suelo BCAA (Alta Resolución)_"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "Symbol": [
                    {
                        "Type": "fill",
                        "Color": "rgba(255, 255, 255, 1)",
                        "ZIndex": null
                    },
                    {
                        "Type": "stroke",
                        "Color": "rgba(70, 100, 255, 1)",
                        "width": "1.2",
                        "lineDash": null,
                        "lineCap": "round",
                        "lineJoin": "round",
                        "ZIndex": null
                    }
                ]
            },
            "customParameters":[
                {
                    "type":"link",
                    "location":"top",
                    "label":"Label Text",
                    "link":"www.domain.com"
                }
            ]
        },
        
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "BCAA 2019",
            "Description":"Mosaico capturado con el dron fotogramétrico de la BCAA específicamente la zona de la Base, capturado el año 2019 reducida en calidad a 120cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "BCAA_2019_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico BCAA 2019 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true        
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "BCAA 2020",
            "Description":"Mosaico capturado con el dron fotogramétrico de la BCAA específicamente la zona del lago Uruguay capturado el año 2020 y reducida en calidad a 120cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "BCAA_2020_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico BCAA 2020 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "BCAA 2025",
            "Description":"Mosaico de la Base Científica Antártica Artigas capturado el 2025 con un dron con sensores LIDAR, esta versión fue Re proyectada a WGS84 y optimizada para mejorar sus tiempos de carga, la imagen original tiene 2cm de pixel en UTM21s y está 2cm~3cm ",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "BCAA_2025_3CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico BCAA 2025 (3cm) COG"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Rocky Cove 2026",
            "Description":"Mosaico de Rocky Cove capturado el 8 Enero de 2026 con un dron DJI Mavic 2 Enterprise Advanced, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento. \n\nSistema de referencia original: EPSG:32721 - UTM21s \nResolución del servicio: 5cm de pixel \nResolución Original: 1,6cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "ROCKY_COVE_2026_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Rocky Cove 2026 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
                {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Camino Catedral 2026",
            "Description":"Mosaico de la Camino Catedral capturado el 8 Enero de 2026 con un dron DJI Mavic 2 Enterprise Advanced, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento. \n\n Sistema de referencia original: EPSG:32721 - UTM21s \n Resolución del servicio: 5cm de pixel \n Resolución Original: 1,6cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "CAMINO_CATEDRAL_2026_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Camino Catedral 2026 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
                {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Punta Verde 2026",
            "Description":"Mosaico de la Punta Verde capturado el 14 de Enero de 2026 con un dron DJI Mavic 2 Enterprise Advanced, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento. \n\nSistema de referencia original: EPSG:32721 - UTM21s \nResolución del servicio: 5cm de pixel \nResolución Original: 1,7cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "PUNTA_VERDE_2026_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Punta Verde 2026 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Camino a Drake 2026",
            "Description":"Mosaico del Camino a Drake capturado el 14 de Enero de 2026 con un dron DJI Mavic 2 Enterprise Advanced, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento. \n\nSistema de referencia original: EPSG:32721 - UTM21s \nResolución del servicio: 5cm de pixel \nResolución Original: 1,7cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "CAMINO_DRAKE_2026_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Camino a Drake 2026 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Península de Drake 2022",
            "Description":"Mosaico capturado con el dron fotogramétrico de la Península de Drake capturado el año 2022 y reducida en calidad a 120cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "Ortomosaico_Peninsula_De_Drake_2022_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Península de Drake 2022 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Bahía de Drake 2026",
            "Description":"Mosaico de la Bahía Esperanza capturado el 30 de Enero de 2026 con un dron DJI Mavic 2 Enterprise Advanced, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento. Sistema de \n\nreferencia original: EPSG:32721 - UTM21s \nResolución del servicio: 5cm de pixel \nResolución Original: 1,6cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "BAHIA_DE_DRAKE_2026_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Bahía de Drake 2026 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Aeródromo 2022",
            "Description":"Mosaico capturado con el dron fotogramétrico de la Zona del Aeródromo de la isla rey jorge capturado el año 2022 y reducida en calidad a 120cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "Ortomosaico_Aerodromo_2022_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Aeródromo 2022 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },        

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Tanques Rusos 2022",
            "Description":"Mosaico capturado con el dron fotogramétrico de la zona de los Tanques Rusos capturado el año 2022 y reducida en calidad a 120cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "Tanques_Rusos_2022_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Tanques Rusos 2022 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Tanques Rusos 2024",
            "Description":"Mosaico capturado con el dron fotogramétrico de la zona de los Tanques Rusos capturado el año 2023-2024 y reducida en calidad a 5cm de pixel para reducir su peso.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "Tanques_Rusos_2024_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Tanques Rusos 2024 (5CM)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Tanques Rusos 2025",
            "Description":"Mosaico capturado con el dron fotogramétrico de la zona de los Tanques Rusos capturado el año 2025 con 5cm de pixel",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "Tanques_Rusos_2025_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Tanques Rusos 2025 (5CM)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Isla Ardley 2024",
            "Description":"Mosaico de fotos (RGB) de la zona de Mosaico Isla Ardley facilitado por el Servicio de Sensores Remotos Aeroespaciales con 3cm de pixel",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/SSRA_COG/wms",
                "LayerNames": [
                    "Isla_Ardley_2024_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Isla Ardley 2024 (5cm)"
                ],
                "Attributions_TXT":"FAU - SSRA",
                "Attributions_URL":"https://sensores.fau.mil.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Isla Ardley IR 2024",
            "Description":"Mosaico de fotos (IR) de la zona de Mosaico Isla Ardley facilitado por el Servicio de Sensores Remotos Aeroespaciales con 3cm de pixel",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/SSRA_COG/wms",
                "LayerNames": [
                    "Isla_Ardley_IR_2024_7CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Isla Ardley IR 2024 (7cm)"
                ],
                "Attributions_TXT":"FAU - SSRA",
                "Attributions_URL":"https://sensores.fau.mil.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },
        
        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Punta Nebles 2024",
            "Description":"Mosaico de fotos (RGB) de la zona de Punta Nebles facilitado por el Servicio de Sensores Remotos Aeroespaciales con 3cm de pixel",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/SSRA_COG/wms",
                "LayerNames": [
                    "Punta_Nebles_2024_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Punta Nebles 2024 (5cm)"
                ],
                "Attributions_TXT":"FAU - SSRA",
                "Attributions_URL":"https://sensores.fau.mil.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Punta Nebles IR 2024",
            "Description":"Mosaico de fotos (IR) de la zona de Punta Nebles facilitado por el Servicio de Sensores Remotos Aeroespaciales con 3cm de pixel",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/SSRA_COG/wms",
                "LayerNames": [
                    "Punta_Nebles_IR_2024_9CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Punta Nebles IR 2024 (9cm)"
                ],
                "Attributions_TXT":"FAU - SSRA",
                "Attributions_URL":"https://sensores.fau.mil.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Bahía Esperanza 2025",
            "Description":"Mosaico de la Bahía Esperanza capturado el 2025 con un dron con sensores LIDAR, esta versión fue reducida en resolución para mejorar los tiempos de carga y rendimiento.\n Sistema de referencia origial: EPSG:32721 - UTM21s \nResulución del servicio: 5cm de pixel \nResolución Original: 1,24cm de pixel.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_COG/wms",
                "LayerNames": [
                    "ECARE_2025_5CM_EPSG_32721_UTM21s_COG"
                ],
                "LayerTitles": [
                    "Mosaico Bahía Esperanza 2025 (5cm)"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Curvas de nivel Bahía Esperanza 2025",
            "Description":"Curvas de nivel de la zona de la Bahía Eseranza, Curvas capturadas cada 5m, Generadas a partir del modelo digital de terreno de vuelo de dron, utilizando software DJI terra, con GCP, Dron utilizado: DJI Mavic 2 Enterprise advanced, Fecha de vuelo: ENERO 2025. Fecha de creación: 13 de Mayo de 2025.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_Vector/wms",
                "LayerNames": [
                    "Curvas_de_Nivel_ECARE_5m_2025"
                ],
                "LayerTitles": [
                    "Curvas de Nivel ECARE 5m 2025"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        },

        {
            "Type": "Layer",
            "Activated": true,
            "CustomName": "Base Científica Antártica Artigas",
            "Description":"Capa vectorial generada por el IGM de la zona de BCAA y el resto de la Isla Rey Jorge, tiene curvas de nivel de 1m de separación de cotas para la zona de la BCAA",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_BCAA/wms",
                "LayerNames": [
                    "Antena",
                    "Estacion_geodésica_activa",
                    "Cañeria_de_aguas_residuales",
                    "Cañeria_de_agua_potable",
                    "Estacion_meteorológica",
                    "Sendas",
                    "Puentes",
                    "Cursos_de_agua",
                    "Curvas_de_nivel",
                    "Pistas_de_aterrizaje",
                    "Helipuerto",
                    "Lagos",
                    "Edificación",
                    "Tanques",
                    "Musgo",
                    "Cajas_de_inspección",
                    "Area_reciclaje"
                ],
                "LayerTitles": [
                    "Antena",
                    "Estacion geodésica activa",
                    "Cañería de aguas residuales",
                    "Cañería de agua potable",
                    "Estacion meteorológica",
                    "Sendas",
                    "Puentes",
                    "Cursos de agua",
                    "Curvas de nivel",
                    "Pistas de aterrizaje",
                    "Helipuerto",
                    "Lagos",
                    "Edificación",
                    "Tanques",
                    "Musgo",
                    "Cajas de inspección",
                    "Area de reciclaje"
                ],
                "Attributions_TXT":"IGM",
                "Attributions_URL":"http://igm.gub.uy/",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": false,
                "Extent":{
                    "CRS": "EPSG:4326",
                    "XMax": -58.8921448549992,
                    "XMin": -58.92119319853547,
                    "YMax": -62.18113068690039,
                    "YMin": -62.18873172242243
                }                
            }
        },

        {
            "Type": "Layer",
            "Activated": false,
            "CustomName": "Zonas Protegidas Antartida (ZAEP)",
            "Description":"Zonas Especialmente protegidas (ZAEP) proporcionadas por Secretariat of the Antarctic Treaty.",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/ZAEP/wms",
                "LayerNames": [
                    "ZAEP_ATS"
                ],
                "LayerTitles": [
                    "Zona Antartica Especialmente Protegida - ATS"
                ],
                "Attributions_TXT":"ATS",
                "Attributions_URL":"https://www.ats.aq/s/protected.html",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": false
            }
        },

        {
            "Type": "Layer",
            "Activated": true,
            "CustomName": "Bases Antárticas",
            "Description":"Puntos con todas las bases antárticas facilitada por SCAR de la base ADD 2021 bajo licencia (CC BY 4.0)",
            "Format": "WMS",
            "Parameters": {
                "URL": "https://gs.igm.gub.uy/geoserver/IGM_Vector/wms",
                "LayerNames": [
                    "Bases_Antarticas"
                ],
                "LayerTitles": [
                    "Bases Antartida"
                ],
                "Attributions_TXT":"SCAR ADD 2021",
                "Attributions_URL":"https://scar.org/library-data/maps/add-digital-database",
                "ImagFormat": "image/png",
                "Transparent": true,
                "Tiled": true
            }
        }
    ]
};